import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import blockStyles from '../styles/block.styles';
import videoSkeletonStyles from '../skeleton/video-skeleton.styles';
export default css `
  ${componentStyles}
  ${blockStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/

:host {
    flex-grow: 1;
  }

  :host([preview]) {
    pointer-events: none;
  }

  .video-list-page {
    /* background: var(--p-bg-light); */
    padding: var(--p-gap) 0 var(--p-section-padding);
  }

  .container {
    width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
    margin-inline: auto;
    display: grid;
    gap: var(--p-gap);
  }

  .page-layout-hideFolderTree .container {
    grid-template-columns: 1fr;
  }

  .page-layout-default .container {
    grid-template-columns: 250px 1fr;
  }

  @media (max-width: 768px) {
    .page-layout-default .container {
      grid-template-columns: 1fr;
    }

    .video-listing li {
      margin-bottom: 0.5em;
    }
  }

  header {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    margin-bottom: 1rem;
    justify-content: space-between;
    outline: none; //we will focus on this when a folder is selected but dont want the outline to be visible
  }

  @media (max-width: 768px) {
    header {
      flex-direction: column;
    }
  }

  h1 {
    display: inline-block;
    font-size: var(--p-h2-font-size);
    margin: 0;
    margin-right: 1rem;
    line-height: var(--p-h2-line-height);
  }

  .items {
    display: inline-block;
    font-size: var(--p-font-size-small);
    opacity: var(--p-text-meta-opacity);
  }

  @media (max-width: 768px) {
    .file-tree {
      display: none;
    }
  }

  .skip-link {
    position: absolute;
    left: -9999px;
    padding: 0.5em 1em;
    background-color: var(--p-bg);
    color: var(--p-text-color);
  }

  .skip-link:focus {
    position: static;
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  .video-header:focus {
    outline: none;
  }

  .video-listing {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-default-width), 1fr));
    gap: var(--p-video-grid-gap);
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .item-layout-card .video-listing {
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-card-width), 1fr));
  }

  .item-layout-portrait .video-listing {
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-portrait-width), 1fr));
  }

  .item-layout-full .video-listing {
    grid-template-columns: repeat(auto-fill, minmax(var(--p-video-item-full-width, 100%), 1fr));
  }

  ${videoSkeletonStyles}

  :host([dark]) {
    --p-section-bg: var(--p-bg-dark);
    --p-text-color: var(--p-text-color-light);
    --p-expand-bg-hover: var(--p-text-color-light-contrast-100);
    --p-expand-selected-bg-hover: var(--p-text-color-light-contrast-100);
  }
`;
